import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { PATH } from '../../constants/path';
import { ERHA_CHAT_API_URL, ERHA_CHAT_KEY, ERHA_CHAT_SCRIPT_URL } from '../../constants';

const ERHA_CHAT_SCRIPT_ID = 'erha-chat';

const ERHA_CHAT_PATHS = [
    PATH.CASHBACK_EBON,
    PATH.MERCHANTPAGE_EBON_PATH,
    PATH.EBON_CONFIRMATION_PATH,
    PATH.EBON_ERROR_PATH,
    PATH.EBON_DOWNLOAD_BILL_PATH,
    PATH.EBONS_REMINDER_PATH,
    PATH.FAQ_PATH
];

const toggleErhaChat = pathname => {
    if (!window.ErhaChat) {
        return;
    }

    if (ERHA_CHAT_PATHS.some(path => pathname.startsWith(path))) {
        window.ErhaChat.show();
    } else {
        window.ErhaChat.hide();
    }
};

const ErhaChatComponent = ({ location }) => {
    useEffect(() => {
        if (!ERHA_CHAT_KEY || document.getElementById(ERHA_CHAT_SCRIPT_ID)) {
            return;
        }

        const script = document.createElement('script');
        script.id = ERHA_CHAT_SCRIPT_ID;
        script.async = true;
        script.src = ERHA_CHAT_SCRIPT_URL;
        script.dataset.key = ERHA_CHAT_KEY;
        script.dataset.api = ERHA_CHAT_API_URL;
        script.dataset.hidden = 'true';
        script.addEventListener('load', () => toggleErhaChat(window.location.pathname));
        document.body.appendChild(script);
    }, []);

    useEffect(() => {
        toggleErhaChat(location.pathname);
    }, [location.pathname]);

    return null;
};

ErhaChatComponent.propTypes = {
    location: PropTypes.object.isRequired
};

export default withRouter(ErhaChatComponent);



// WEBPACK FOOTER //
// ./src/components/erha/ErhaChatComponent.js